export default __webpack_public_path__ + "assets/profeature-card-small2.78c6d796178945188e85c8a72211fc49.jpg";